export const BASE_URL = process.env.REACT_APP_BASE_URL

export const IMAGE_PROFILE_URL = process.env.REACT_APP_IMAGE_URL

export const APP_NAME = '@admin'

export const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === 'true'
